<!--帮助中心 Sag 2020-04-21-->
<template>
  <ts-page-layout class="its-help" center :left="'20%'" ref="page">
    <help-menu slot="left" class="its-help-menu-aside" :menus="menus" :father-action="menuAction" :isLoading="isLoading"></help-menu>
    <div class="its-center">
      <div class="its-center-title">解决方法</div>
      <div class="its-main-container" v-html="answer" v-loading="isLoading"></div>
    </div>
  </ts-page-layout>
</template>
<script>
import HelpMenu from './components/HelpMenu'
import {helpApi} from '../../../utils/api'
export default {
  name: 'Help',
  components: {
    HelpMenu
  },
  data () {
    return {
      isLoading: false,
      menus: [],
      answer: ''
    }
  },
  mounted () {
    this.getFaqs()
    this.updateAsideWidth()
    this.$root.switchNavigation('帮助中心')
  },
  methods: {
    updateAsideWidth: function () {
      let vm = this
      setTimeout(function(){
         vm.$refs.page.setFixedWidth('.its-help-menu-pos', '.aside-left')
      }, 50)
    },
    getFaqs: function () {
      this.isLoading = true
      helpApi.getFaqs('PC').then((res)=>{
        this.menus = res
        this.isLoading = false
      })
    },
    menuAction: function (data) {
      console.log(data)
      if (data.type == 'select') {
        this.answer = data.answer.content
      } else if (data.type === 'viewAnswer') {
        this.answer = data.faq.content
      }
    }
  }
}
</script>
<style scoped>
#app {
  height: auto;
}
.its-help {
  background: transparent;
}
.its-center-title {
  width: 100%;
  padding: 20px;
  margin-bottom: 10px;
  font-size: 20px;
  color: #5591FE;
  background: white;
}
.its-help>>>.aside-center.page-div{
  background: transparent;
}
.its-center {
  /* background: white; */
  margin-top: 10px;
}
.its-main-container {
  background: white;
  padding: 20px;
  margin-bottom: 20px;
  box-sizing: border-box;
  min-height: 100px;
}
.its-main-container>>> img{
  max-width: 100%;
}
.its-help>>>.aside-left {
  background: transparent;
}
</style>